export default __webpack_public_path__ + "static/media/My-Zinc-eng.cd65fe85.jpg";